export default "__VITE_ASSET__NqO8iaox__"